import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f2acc00c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f2acc00c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2acc00c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2acc00c')) {
      api.createRecord('f2acc00c', component.options)
    } else {
      api.reload('f2acc00c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f2acc00c&scoped=true", function () {
      api.rerender('f2acc00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordUsedManage/index.vue"
export default component.exports